import { IRequestResult } from "../api-client";
import { BaseApi } from "../base";

import { ISubscriptionDataV3 } from "./interfaces";

export default class AccountsBillingV3Api extends BaseApi {
  protected readonly service = "accounts-billing";
  protected readonly version = 3;

  fetchActivatedSubscriptions = (): Promise<IRequestResult<ISubscriptionDataV3>> => this.get("subscriptions");
}
